import { render, staticRenderFns } from "./EmployeesView.vue?vue&type=template&id=29f87138&scoped=true&"
import script from "./EmployeesView.vue?vue&type=script&lang=js&"
export * from "./EmployeesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f87138",
  null
  
)

export default component.exports